module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('br'), _vm._v(" "), (_vm.show_spinner) ? _c('div', {
    staticClass: "sk-circle"
  }, [_c('div', {
    staticClass: "sk-circle1 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle2 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle3 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle4 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle5 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle6 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle7 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle8 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle9 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle10 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle11 sk-child"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle12 sk-child"
  })]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 push-4"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v("\n                  Vol recarregar la pagina?\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v("\n                 \n                 \n            "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.reloadPage()
      }
    }
  }, [_c('i', {
    staticClass: "icon-reload"
  })])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h4', [_c('strong', [_vm._v("NO ES TROBEN ELEMENTS")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe406300"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partials/GeneralSpinner.vue
// module id = 570
// module chunks = 1